/* Load demonstration videos near the viewport; only visible videos play. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const visible = new Set();
  const load = video => {
    if (video.dataset.techLoaded) return;
    video.dataset.techLoaded = 'true';
    video.src = video.dataset.techSrc;
    video.load();
  };
  const play = video => {
    if (document.hidden || reducedMotion.matches || !video.hasAttribute('data-tech-autoplay')) return;
    load(video);
    const promise = video.play();
    if (promise) promise.catch(() => {});
  };
  const observe = 'IntersectionObserver' in window;
  const loader = observe ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      load(entry.target);
      loader.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' }) : null;
  const playback = observe ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visible.add(entry.target);
        play(entry.target);
      } else {
        visible.delete(entry.target);
        entry.target.pause();
      }
    });
  }, { threshold: 0.3 }) : null;
  const init = () => document.querySelectorAll('[data-tech-video]:not([data-tech-bound])').forEach(video => {
    video.dataset.techBound = 'true';
    // Match the source Technology pages' clean, looping demonstrations. Keep
    // manual controls available when the visitor has requested reduced motion.
    video.controls = reducedMotion.matches;
    videos.add(video);
    video.addEventListener('pointerdown', () => load(video), { once: true });
    video.addEventListener('focus', () => load(video), { once: true });
    if (observe) {
      loader.observe(video);
      playback.observe(video);
    } else load(video);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach(video => video.pause());
    else visible.forEach(play);
  });
  reducedMotion.addEventListener('change', () => {
    videos.forEach(video => { video.controls = reducedMotion.matches; });
    if (reducedMotion.matches) videos.forEach(video => video.pause());
    else visible.forEach(play);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
